import React, { useState } from 'react';

export default function DoubtAssistanceComponent (props) {
    function toggleDoubtSupport() {
        props.addToCartRef.current.click()
    }

    return (
        <section id = "paymentsDescription">
            <div className = "container mb-5">
                <img alt = "" src = "https://media.geeksforgeeks.org/img-practice/Layer2-1621676465.png" />
                <ul className = "mt-5">
                    <li className = "text-left urw-din text-muted">Doubts eating up much of your time while learning to code?</li>
                    <li className = "text-left urw-din text-muted mt-3">Unresolved doubts leading to slow growth, abandoned codes and frustration?</li>
                    <li className = "text-left urw-din text-muted mt-3">Our Doubt Assistance feature is here to clear your doubts, no matter how big or small!</li>
                    <li className = "text-left urw-din text-muted mt-3">Ensure a more productive & speedy learning experience with dedicated help from GeeksforGeeks!</li>    
                </ul>
                {!props.isDoubtSupportAdded && 
                    <button onClick = {toggleDoubtSupport} disabled = {props.isDoubtSupportButtonClicked} className = "btn btn-dark col-9">Add to cart</button>
                }
                {props.isDoubtSupportAdded && props.doubtSupportPrice != 0  && 
                    <button onClick = {toggleDoubtSupport} disabled = {props.isDoubtSupportButtonClicked} className = "btn btn-outline-danger col-9">Remove</button>
                }
            </div>
        </section>
    );
}